import React from 'react'
import { Link } from 'react-router-dom'
import SignIn from '../../components/SignIn'
import Register from '../../components/Register'
import { Button, Form, Message} from 'semantic-ui-react'
import { doConfirm, isAuthenticated } from '../../services/self'
import logo from '../../Nlogo.png'

 export default class Recover extends React.Component {

   state = {
     isSubmitting: false,
     signedIn: false,
     errorMessage: '',
     isOpen: false,
     username: '',
     code: '',
     submitted: false,
     confirmed: false
   }

     doConfirm = (event, serializedForm) => this._doConfirm(event, serializedForm)

   _doConfirm(event, serializedForm){
     event.preventDefault()


     console.log(this.state.username);
     doConfirm(this.state.username, this.state.code).then((result) => {
       let confirmation = result;

       console.log(`Result returned is:  ${result}`);
       if(confirmation == "SUCCESS"){
         console.log(`Confirmation is SUCCESS!!!`);
         this.setState({confirmed: true});
       }
     })

     this.setState({submitted: true})

   }


   render() {
     return (
    <div className="none">
            <div className="App">
            <div className="Logo">
                <Link className="home-link2" to='/'><img src={logo} className="App-logo" alt="logo" /></Link>
                <Link className="home-link" to='/'>Developer</Link>
            </div>

            <div className="Navbar-Div">
              <nav className="App-navbar">


                <Link className="Centered-link" to='/case-studies'>Case Studies</Link>
                <Link className="Centered-link" to='/getting-started'>Getting Started</Link>
                <Link className="Centered-link" to='/documentation'>Docs</Link>
                <Link className="Centered-link" to='/tools'>Tools</Link>
                <Link className="Centered-link" to='/community'>Community</Link>

                {isAuthenticated() ? (<Link className="Centered-link" to='/apis'>Console</Link>) : ''}
                {isAuthenticated() ? (<Link className="right" to='' onClick={() => this.logout()}>Log out</Link>) : ''}
                {isAuthenticated() ? '' : (
                <span className="right">
                
                <Register className="right-link" />
                </span>
                )}


              </nav>
            </div>

            <div className="App-banner">

              <span className="orange-bold"> WATCH THE WEBINAR: </span> BST Global and Newforma Strategic Alliance <a className="newforma-world-link" href="https://www.newforma.com/bst/">Learn More</a>

            </div>

    <div className="main-content">
<div className="confirm-form">
      <Form onSubmit={this.doConfirm} error={!!this.state.errorMessage} loading={this.state.isSubmitting}>
        <Form.Input label='Username' name='username' onChange={ (e) => this.setState({ username: e.target.value }) }/>
        <Form.Input label='Code' name='code' onChange={ (e) => this.setState({ code: e.target.value }) } />

        <Message error content={this.state.errorMessage} />
        {this.state.confirmed ? <Message header='Confirmation Complete'> You have successfully completed your registration. Please Home to login. <span className="create-btn"><Link to='/'>HOME</Link></span></Message> : '' }

          <Button primary type='submit'>Confirm</Button>

      </Form>

</div>

  {/*  <input type="text" placeholder="username" ref={(input) => {this.username = input}}/>
    <input type="text" placeholder="code" ref={(input) => {this.code = input}}/>
    <button onClick={(e) => this.doConfirm(e)}>Confirm</button>*/}
  </div>
</div>
</div>
)}
}



/** WEBPACK FOOTER **
 ** ./src/pages/Confirm/index.js
 **/